import React, { useRef, useState } from 'react';
import { uploadpost } from 'services/utils';
import { putpost } from 'services/utils';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from 'views/pages/manage/common/constant';
import { successToast, failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { regex } from 'views/pages/manage/common/constant';
import CustomButton from '../../../../../../../components/CustomButton';
import { RiDeleteBin5Line } from "react-icons/ri";
import { ReactComponent as EyeIcon } from 'assets/img/svg/eye_open.svg';
import { viewDocument } from './DocumentViewerDialog';

const allowedExt = ['jpeg', 'png', 'pdf', 'jpg'];

const FileAttachButton = ({
  label = "Attach",
  entityId,
  applicationQuotationDetailsId,
  documentType,
  onUploadSuccess,
  disabled,
  applicationOtherChargeId,
  applicationId,
  psid,
  s3Key = ''

}) => {

  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [currentId, setCurrentId] = useState(null)

  const handleClick = () => {
    if(fileInputRef.current){
        fileInputRef.current.click();
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);

    try {
      if (!validateFile(file)) {
        setUploading(false);
        return;
      }
      getPresignedUrl(file);
    } catch (err) {
      failureToast("Error selecting file!");
      setUploading(false);
    }

    fileInputRef.current.value = '';
  };

  const validateFile = (file) => {
    const ext = file.name.split('.').pop();
    if (!allowedExt.includes(ext)) {
      failureToast(`Allowed extensions: ${allowedExt.join(', ')}`);
      return false;
    }

    const baseName = file.name.split('.')[0];
    if (!regex.alphaNumericWithSpaceAndUnderscore.test(baseName)) {
      failureToast("Rename file without special characters.");
      return false;
    }

    if (file.size / (1024 * 1024) > 10) {
      failureToast("File size should not exceed 10 MB.");
      return false;
    }

    return true;
  };

  const getPresignedUrl = (file) => {
    const reqData = {
      bulk: false,
      fileName: file.name,
      sourceId: 1,
      keyValue: new Date(),
      docType: file.name.split('.')[1],
      serviceName: "ENROLLMENT_CONCESSION_UPLOAD",
    };

    putpost(endpoint.fetchS3Url.getUrl,
      (res) => saveFileToStorage(res.data, file),
      () => { failureToast("Error generating upload link"); setUploading(false); },
      reqData,
      "post"
    );
  };

  const saveFileToStorage = (res, file) => {
    uploadpost(
      res.storage,
      () => saveFileMeta(res, file),
      () => { failureToast("Upload failed"); setUploading(false); },
      file,
      file.type,
      file.name
    );
  };

  const saveFileMeta = async (res, file) => {
    const payload = {
      applicationQuotationDetailsId,
      s3Key: res?.key,
      documentType,
      processInstanceId: res?.processId,
      fileName: file.name,
      applicationConcessionId: entityId,
      applicationOtherChargeId:applicationOtherChargeId ,
      applicationId: applicationId,
       psid: psid,

    };

    const response = await fetchAllPostPromisedData(endpoint.otherChargesDocument?.upload, payload, 'post');
    setUploading(false);
    if (response?.code === 200) {
      successToast("File uploaded successfully!");
      setCurrentId(response?.data?.id)
      onUploadSuccess && onUploadSuccess(res?.key);
    } else {
      failureToast("Failed to save file metadata.");
    }
  };

  

  return (
    <>
      <div className='d-flex'>
      <CustomButton
        className="regular-small BTNbgChange"
        content={uploading ? <i className="fas fa-spinner fa-spin" /> : label}
        onClick={handleClick}
        disabled={disabled || uploading }
        forTable={true}
        permissionType={'C'}
        permissionSet={'C'}      />
      <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
      {currentId &&<div className='cursor ml-1'> <EyeIcon onClick = {()=>viewDocument(s3Key)}  height={35}/></div>}
      </div>
    </>
  );
};

export default FileAttachButton;
